<template>
  <div class="card-block">
    <h3 class="card-title">
      Manual Credit
    </h3>
    <p class="card-text">
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <div class="bg-blue-grey-100 p-30">
            <alert v-show="showAlert"
              alertClass="m-b-25 alert-dismissible"
              v-bind:type="`${ (successResponse) ? 'success' : 'danger' }`"
              v-bind:iconClass="`${ (successResponse) ? 'md-check' : 'md-close' }`">
              <span v-if="successResponse">{{successResponse}}</span>
              <span v-else-if="errorResponse">{{errorResponse}}</span>
            </alert>
            <form v-on:submit.prevent="onSubmitManualCredit">
              <form-group>
                <label class="form-control-label form-radio">Choose Type</label>
                <div class="radio-custom radio-primary radio-inline">
                  <input type="radio" id="deposit" value="deposit" v-model="transactionType">
                  <label for="payplan">Add</label>
                </div>
                <div class="radio-custom radio-primary radio-inline">
                  <input type="radio" id="deduct" value="deduct" v-model="transactionType">
                  <label for="payplan">Deduct</label>
                </div>
              </form-group>
              <form-group v-bind:error="formErrors.first('amount')">
                <label class="form-control-label" for="amount">Amount (THB)</label>
                <input type="number" class="form-control" autocomplete="off" v-model="amount">
              </form-group>
              <form-group v-bind:error="formErrors.first('description')">
                <label class="form-control-label" for="description">Description</label>
                <input type="text" class="form-control" autocomplete="off" v-model="description">
              </form-group>
              <form-group>
                <label class="form-control-label" for="amount">Note for admin (Not show to user)</label>
                <input type="text" class="form-control" autocomplete="off" v-model="note">
              </form-group>
              <button type="submit" class="btn btn-success" :disabled="isSubmiting" v-bind:class="{ 'btn-default': isSubmiting }">
                <div class="loader vertical-align-middle loader-circle loader-form" v-if="isSubmiting"></div> Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </p>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { Validator } from 'vee-validate';
import Alert from 'components/Alert';
import FormGroup from 'components/forms/FormGroup';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    Alert,
    FormGroup,
    LoadingIndicator,
  },
  props: {
    team: {
      type: Object,
    },
  },
  watch: {
    team: function(value) {
      if (value) {
        //TODO: fetch data ??
      }
    },
    amount: function() {
      if (this.formErrors.has('amount')) {
        this.formErrors.remove('amount');
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
  },
  data: function() {
    return {
      isSubmiting: false,
      isLoading: false,
      showAlert: false,
      validator: null,
      formErrors: null,
      errorResponse: null,
      successResponse: null,
      transactionType: 'deposit',
      description: '',
      amount: 0,
      note: null,
    };
  },
  created: function() {
    this.isLoading = true;

    this.$emit('loadChanged', false);

    this.validator = new Validator();
    this.validator.attach('amount', 'required|min_value:1', { prettyName: 'Amount' });
    this.validator.attach('description', 'required', { prettyName: 'Description' });
    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  methods: {
    onSubmitManualCredit: function() {
      this.showAlert = false;

      this.validator.validateAll({
        amount: this.amount,
        description: this.description,
      })
      .then((success) => {
        if (!success) {
          return;
        }

        this.isSubmiting = true;

        if (this.transactionType === 'deposit') {
          return axios.post(`/api/admin/deposit`, {
            namespace: this.team.namespace,
            credit: this.amount,
            description: this.description,
            note: this.note,
          });
        } else if (this.transactionType === 'deduct') {
          return axios.post(`/api/admin/deduct`, {
            namespace: this.team.namespace,
            credit: this.amount,
            description: this.description,
            note: this.note,
          });
        }
      })
      .then(() => {
        this.isSubmiting = false;

        if (this.transactionType === 'deposit') {
          this.successResponse = this.$t('depositcredit.response.success');
        } else {
          this.successResponse = this.$t('deductcredit.response.success');
        }

        this.errorResponse = null;
        this.showAlert = true;
        this.amount = 0;
        this.description = '';
        this.note = '';

        this.eventHub.$emit('manualAddCreditSuccess');
      })
      .catch((error) => {
        this.isSubmiting = false;
        if (error.response) {
          if (error.response.status === 422) {
            this.errorResponse = error.response.data.credit;
            this.formErrors.addAll(error.response.data);
          } else {
            this.errorResponse = this.$t('team.response.defaultFailed');
          }

          this.showAlert = true;
        }
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// ManualCredit.vue?02040c93